<!--
  应用根组件
  用途：仅作为路由出口；前台/后台布局由各自路由组件负责
-->
<template>
  <router-view />
</template>
